import type { ComponentProps } from 'react'
import { Plug } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import { PartnerSimulator } from './simulator/PartnerSimulator.js'

/** What the partner module contributes to the shells: the Partner Simulator, which plays a partner's system from the browser. */
export const partnerWebModule: WebModule<ComponentProps<typeof PartnerSimulator>['api']> = {
  name: 'partner',
  adminPages: [{ path: '/admin/partner-simulator', label: 'Partner Simulator', title: 'Partner Simulator', icon: Plug, group: 'integration', page: ({ api }) => <PartnerSimulator api={api} /> }],
}
